import { createFileRoute, Outlet } from '@tanstack/react-router';
import {
  PERMISSION_RIDE_TAG,
  PERMISSION_PARKING_TAG,
  PERMISSION_COST_CENTERS,
} from '../../Services/PermissionsService';
import { requirePermissions } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/system_settings')({
  beforeLoad: async ({ context }) => {
    await requirePermissions(
      [PERMISSION_RIDE_TAG, PERMISSION_PARKING_TAG, PERMISSION_COST_CENTERS],
      ['read'],
      '/unauthorized',
      context
    );

    return {
      ...context,
      documentTitle: {
        main: 'table.systemSettings',
        suffix: 'menu.settings',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: SystemSettingsRoute,
});

function SystemSettingsRoute() {
  return <Outlet />;
}
